import { FC, memo, useLayoutEffect } from 'react';

import getExtension from 'common/getExtension';
import SunshineModal, {
  SunshineModalProps,
} from 'components/_core/SunshineModal';

import { Image } from './styles';

const IMAGES_FORMAT: Readonly<string[]> = ['gif', 'jpeg', 'jpg', 'png', 'tiff'];

interface FilePreviewProps extends Pick<SunshineModalProps, 'onClose'> {
  url: string;
  alt?: string;
}

const FilePreview: FC<FilePreviewProps> = ({ alt, onClose, url }) => {
  const extension = getExtension(url);
  const isPicture = Boolean(extension && IMAGES_FORMAT.includes(extension));

  useLayoutEffect(() => {
    if (isPicture) {
      return;
    }

    window.open(url, '_blank');
    onClose();
  });

  if (isPicture) {
    return (
      <SunshineModal isOpen onClose={onClose}>
        <SunshineModal.Header />
        <SunshineModal.Body>
          <Image alt={alt} src={url} />
        </SunshineModal.Body>
      </SunshineModal>
    );
  }
  return null;
};

export default memo(FilePreview);
